module.exports = __webpack_public_path__ + "img/07.0b2b1e4b.jpg";